// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3GZX9","large":"styles_large__1DheQ"};